import { IceDevTools } from "@ice/react";
import { LicenseInfo } from "@mui/x-license";
import { QueryClientProvider } from "@tanstack/react-query";
import { VaporThemeProvider } from "@vapor/react-material";
import {
    AdapterDateFns,
    LocalizationProvider,
} from "@vapor/react-x-date-pickers";
import it from "date-fns/locale/it";
import dayjs from "dayjs";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useTaxManagerAppQueryClient } from "./core/api/utils/useTaxManagerAppQueryClient";
import routes from "./core/commons/routes";
import "./i18n/config";
import { FulfilmentDetail } from "./ui/views/fulfilment-detail/FulfilmentDetail";
import { Home } from "./ui/views/home/Home";
import { ViewWrapper } from "./ui/views/ViewWrapper";

LicenseInfo.setLicenseKey(import.meta.env.VITE_APP_CI_MUI_TOKEN as string);
dayjs.locale("it");

const TaxManagerAppStandaloneWrapper = () => {
    const queryClient = useTaxManagerAppQueryClient();

    return (
        <QueryClientProvider client={queryClient}>
            <ViewWrapper>
                <Routes>
                    <Route path={routes.home()} element={<Home />} />
                    <Route
                        path={routes.fulfilmentDetail()}
                        element={<FulfilmentDetail />}
                    />
                </Routes>
            </ViewWrapper>
            {/* Sibling of ViewWrapper, never inside it: react-toastify
                DROPS a toast emitted while no container is mounted, and
                ViewWrapper unmounts its children behind every loader (the
                workspace, the subscriptions, the policy gate) — exactly
                when the errors of those steps fire. */}
            <ToastContainer />
        </QueryClientProvider>
    );
};

export const TaxManagerAppStandalone = () => {
    return (
        <VaporThemeProvider>
            {/* Bootstrap ufficiale ICE per lo standalone: inizializza l'SDK
                con l'environment indicato e observability disattivata (niente
                traces/logs/metrics OTLP). In modalità modulo è la shell a
                inizializzare l'SDK. Va renderizzato PRIMA del resto
                dell'albero: i hook ICE richiedono l'SDK già creato. */}
            <IceDevTools environment="dev" />
            <LocalizationProvider
                dateAdapter={AdapterDateFns}
                adapterLocale={it}
            >
                <BrowserRouter>
                    <TaxManagerAppStandaloneWrapper />
                </BrowserRouter>
            </LocalizationProvider>
        </VaporThemeProvider>
    );
};
